import { render, staticRenderFns } from "./RemoveIcon.vue?vue&type=template&id=153780bb&scoped=true&"
import script from "./RemoveIcon.vue?vue&type=script&lang=js&"
export * from "./RemoveIcon.vue?vue&type=script&lang=js&"
import style0 from "./RemoveIcon.vue?vue&type=style&index=0&id=153780bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153780bb",
  null
  
)

export default component.exports